export const SITE_IMAGES_LIST_REQUEST = "SITE_IMAGES_LIST_REQUEST";
export const SITE_IMAGES_LIST_SUCCESS = "SITE_IMAGES_LIST_SUCCESS";
export const SITE_IMAGES_LIST_FAIL = "SITE_IMAGES_LIST_FAIL";

export const SITE_IMAGE_UPSERT_REQUEST = "SITE_IMAGE_UPSERT_REQUEST";
export const SITE_IMAGE_UPSERT_SUCCESS = "SITE_IMAGE_UPSERT_SUCCESS";
export const SITE_IMAGE_UPSERT_FAIL = "SITE_IMAGE_UPSERT_FAIL";

export const SITE_IMAGE_UPDATE_REQUEST = "SITE_IMAGE_UPDATE_REQUEST";
export const SITE_IMAGE_UPDATE_SUCCESS = "SITE_IMAGE_UPDATE_SUCCESS";
export const SITE_IMAGE_UPDATE_FAIL = "SITE_IMAGE_UPDATE_FAIL";

export const SITE_IMAGE_DELETE_REQUEST = "SITE_IMAGE_DELETE_REQUEST";
export const SITE_IMAGE_DELETE_SUCCESS = "SITE_IMAGE_DELETE_SUCCESS";
export const SITE_IMAGE_DELETE_FAIL = "SITE_IMAGE_DELETE_FAIL";
